import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaRobot, FaCodeBranch, FaBrain, FaLinkedin, FaEnvelope, FaPhone, FaUser } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section company-info">
            <h3>OPTEAM Services</h3>
            <p>{t('footer.description')}</p>
            <div className="footer-social">
              <a href="https://linkedin.com/company/opteam-services" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>{t('footer.services')}</h4>
            <ul>
              <li>
                <Link to="/solutions" onClick={scrollToTop}>
                  <FaRobot /> {t('footer.servicesList.rpa')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" onClick={scrollToTop}>
                  <FaCodeBranch /> {t('footer.servicesList.lowcode')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" onClick={scrollToTop}>
                  <FaBrain /> {t('footer.servicesList.ai')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>{t('footer.quickLinks')}</h4>
            <ul>
              <li>
                <Link to="/" onClick={scrollToTop}>
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={scrollToTop}>
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/solutions" onClick={scrollToTop}>
                  {t('nav.solutions')}
                </Link>
              </li>
              <li>
                <Link to="/portfolio" onClick={scrollToTop}>
                  {t('nav.portfolio')}
                </Link>
              </li>
              <li>
                <Link to="/resources" onClick={scrollToTop}>
                  {t('nav.resources')}
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop}>
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>{t('footer.contact')}</h4>
            <ul className="contact-list">
              <li>
                <FaUser />
                <span>Paris, France</span>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:contact@opteam-services.com">contact@opteam-services.com</a>
              </li>
              <li>
                <FaPhone />
                <a href="tel:+33638831750">+33 (0) 6 38 83 17 50</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2026 OPTEAM Services. {t('footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
